/**
 * Gets the list of fields for the Vehicle embedded form.
 */
const getAddressFormConfig = async (): Promise<FormConfig[]> => {
  return [
    {
      id: 'defined_by_coordinates',
      label: 'Defined by map selection (address will calculate to nearest street address)',
      type: 'boolean',
      cols: 12,
    },
    {
      id: 'id',
      label: 'Id',
      type: 'number',
      hidden: true,
    },
    {
      id: 'number',
      label: 'Number',
      type: 'text',
      cols: 4,
      readonly: data => {
        return data.defined_by_coordinates === true;
      },
    },
    {
      id: 'street',
      label: 'Street',
      type: 'text',
      cols: 8,
      readonly: data => {
        return data.defined_by_coordinates === true;
      },
    },
    {
      id: 'postal_community',
      label: 'City',
      type: 'text',
      cols: 12,
      readonly: data => {
        return data.defined_by_coordinates === true;
      },
    },
    {
      id: 'state',
      label: 'State',
      type: 'choice',
      options: [
        { value: 'CA', text: 'CA' },
        { value: 'AK', text: 'AK' },
        { value: 'AL', text: 'AL' },
        { value: 'AR', text: 'AR' },
        { value: 'AZ', text: 'AZ' },
        { value: 'CO', text: 'CO' },
        { value: 'CT', text: 'CT' },
        { value: 'DC', text: 'DC' },
        { value: 'DE', text: 'DE' },
        { value: 'FL', text: 'FL' },
        { value: 'GA', text: 'GA' },
        { value: 'HI', text: 'HI' },
        { value: 'IA', text: 'IA' },
        { value: 'IL', text: 'IL' },
        { value: 'IN', text: 'IN' },
        { value: 'ID', text: 'ID' },
        { value: 'KS', text: 'KS' },
        { value: 'KY', text: 'KY' },
        { value: 'LA', text: 'LA' },
        { value: 'MA', text: 'MA' },
        { value: 'MD', text: 'MD' },
        { value: 'ME', text: 'ME' },
        { value: 'MI', text: 'MI' },
        { value: 'MN', text: 'MN' },
        { value: 'MO', text: 'MO' },
        { value: 'MS', text: 'MS' },
        { value: 'MT', text: 'MT' },
        { value: 'NC', text: 'NC' },
        { value: 'ND', text: 'ND' },
        { value: 'NE', text: 'NE' },
        { value: 'NH', text: 'NH' },
        { value: 'NJ', text: 'NJ' },
        { value: 'NM', text: 'NM' },
        { value: 'NV', text: 'NV' },
        { value: 'NY', text: 'NY' },
        { value: 'OH', text: 'OH' },
        { value: 'OK', text: 'OK' },
        { value: 'OR', text: 'OR' },
        { value: 'PA', text: 'PA' },
        { value: 'RI', text: 'RI' },
        { value: 'SC', text: 'SC' },
        { value: 'SD', text: 'SD' },
        { value: 'TN', text: 'TN' },
        { value: 'TX', text: 'TX' },
        { value: 'UT', text: 'UT' },
        { value: 'VA', text: 'VA' },
        { value: 'VT', text: 'VT' },
        { value: 'WA', text: 'WA' },
        { value: 'WI', text: 'WI' },
        { value: 'WY', text: 'WY' },
        { value: 'WV', text: 'WV' },
      ],
      readonly: data => {
        return data.defined_by_coordinates === true;
      },
      cols: 6,
    },
    {
      id: 'postal_code',
      label: 'Zip',
      type: 'text',
      cols: 6,
      readonly: data => {
        return data.defined_by_coordinates === true;
      },
    },
    {
      id: 'coordinates',
      label: 'Coordinates',
      type: 'text',
      hidden: true,
      cols: 12,
    },
  ];
};

/**
 * Returns a map of functions for retrieving lists of fields for various forms.
 */
export const useFieldConfigsAddress = () => ({
  getAddressFormConfig,
});
